"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchPublicExperimentTreatmentsFromEarlyRequest = exports.fetchExperimentTreatmentsFromEarlyRequest = void 0;

var _q = _interopRequireDefault(require("q"));

var _PortalIdParser = _interopRequireDefault(require("PortalIdParser"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _noAuthApiClient = _interopRequireDefault(require("hub-http/clients/noAuthApiClient"));

var _ActionTypes = require("pricing-pages-unified-ui/constants/ActionTypes");

var _ExperimentConstants = require("pricing-pages-unified-ui/constants/ExperimentConstants");

// NOTE: If changing experiment keys to check, make sure you do it here AND in the proper earlyRequester file
var fetchExperimentTreatments = function fetchExperimentTreatments() {
  var identifier = _PortalIdParser.default.get();

  return _apiClient.default.post('treatments/v1/bulk-get', {
    data: [{
      key: 'pricing-page-monetization-245',
      identifier: identifier
    }, {
      key: _ExperimentConstants.WP006_TREATMENT_KEY,
      identifier: identifier
    }, {
      key: _ExperimentConstants.MON317_TREATMENT_KEY,
      identifier: identifier
    }, {
      key: _ExperimentConstants.MON307_TREATMENT_KEY,
      identifier: identifier
    }, {
      key: 'growth-cbx-279',
      identifier: identifier
    }, {
      key: 'growth-cbx-332',
      identifier: identifier
    }]
  });
};

var dispatchRequestSucceeded = function dispatchRequestSucceeded(result, dispatch) {
  // Make this agnostic to whether we're using the bulk treatment fetch
  // which returns an array, or single treatment fetch which returns just one
  // treatment, not in an array
  if (!Array.isArray(result)) {
    result = [result];
  }

  dispatch({
    type: _ActionTypes.EXPERIMENT_TREATMENTS_RECEIVED,
    payload: {
      treatments: result
    }
  });
};

var fetchExperimentTreatmentsFromEarlyRequest = function fetchExperimentTreatmentsFromEarlyRequest() {
  return function (dispatch) {
    dispatch({
      type: _ActionTypes.EXPERIMENT_TREATMENTS_REQUESTED
    });
    var earlyRequest = window.quickFetch && window.quickFetch.getRequestStateByName('experiment-early-request');

    if (!earlyRequest) {
      return fetchExperimentTreatments().then(function (result) {
        dispatchRequestSucceeded(result, dispatch);
      }).catch(function (error) {
        dispatch({
          type: _ActionTypes.EXPERIMENT_TREATMENTS_FAILED,
          error: error
        });
      });
    }

    return new _q.default.Promise(function (resolve) {
      earlyRequest.whenFinished(function (result) {
        dispatchRequestSucceeded(result, dispatch);
        resolve(result);
        window.quickFetch.removeEarlyRequest('experiment-early-request');
      });
      earlyRequest.onError(function () {
        fetchExperimentTreatments().then(function (result) {
          dispatchRequestSucceeded(result, dispatch);
          resolve(result);
        }).catch(function (error) {
          dispatch({
            type: _ActionTypes.EXPERIMENT_TREATMENTS_FAILED,
            error: error
          });
          resolve([]);
        });
        window.quickFetch.removeEarlyRequest('experiment-early-request');
      });
    });
  };
}; // NOTE: If changing experiment keys to check, make sure you do it here AND in the proper earlyRequester file


exports.fetchExperimentTreatmentsFromEarlyRequest = fetchExperimentTreatmentsFromEarlyRequest;

var fetchPublicExperimentTreatments = function fetchPublicExperimentTreatments() {
  var UTK = window.__HUBSPOT_UTK;

  if (UTK) {
    return _noAuthApiClient.default.post('treatments/v1/bulk-get', {
      data: [{
        key: 'public-pricing-page-monetization-245p',
        identifier: UTK
      }, {
        key: 'growth-cbx-279p',
        identifier: UTK
      }, {
        key: 'growth-cbx-332p',
        identifier: UTK
      }]
    });
  } // should never get here, but if public but no UTK, just resolve


  return _q.default.Promise.resolve();
};

var fetchPublicExperimentTreatmentsFromEarlyRequest = function fetchPublicExperimentTreatmentsFromEarlyRequest() {
  return function (dispatch) {
    var earlyRequest = window.quickFetch && window.quickFetch.getRequestStateByName('experiment-early-request');

    if (!earlyRequest) {
      // If we don't have an early request it means we likely didnt have
      // a UTK and didnt request the treatment
      return _q.default.Promise.resolve();
    }

    dispatch({
      type: _ActionTypes.EXPERIMENT_TREATMENTS_REQUESTED
    });
    return new _q.default.Promise(function (resolve) {
      earlyRequest.whenFinished(function (result) {
        // Make this agnostic to whether we're using the bulk treatment fetch
        // which returns an array, or single treatment fetch which returns just one
        // treatment, not in an array
        dispatchRequestSucceeded(result, dispatch);
        resolve(result);
        window.quickFetch.removeEarlyRequest('experiment-early-request');
      });
      earlyRequest.onError(function () {
        fetchPublicExperimentTreatments().then(function (result) {
          dispatchRequestSucceeded(result, dispatch);
          resolve(result);
        }).catch(function (error) {
          dispatch({
            type: _ActionTypes.EXPERIMENT_TREATMENTS_FAILED,
            error: error
          });
          resolve([]);
        });
        window.quickFetch.removeEarlyRequest('experiment-early-request');
      });
    });
  };
};

exports.fetchPublicExperimentTreatmentsFromEarlyRequest = fetchPublicExperimentTreatmentsFromEarlyRequest;


//////////////////
// WEBPACK FOOTER
// ./js/actions/EarlyRequestExperimentActions.js
// module id = 894
// module chunks = 5 6